import React from "react";
import { SiteHeader } from "../components/header/SiteHeader";
import { CaseReviewSection } from "../components/home/CaseReviewSection";
import { CaseResult } from "../components/home/CaseResult";
import { MoreWins } from "../components/home/MoreWins";
import { Hero } from "../components/home/Hero";
import { TrustSection } from "../components/home/TrustSection";
import { ResourceGallery } from "../components/home/ResourceGallery";
import { SiteFooter } from "../components/SiteFooter";
type HomeProps = {
  showReviewNotes: boolean;
  showEmptyEvents: boolean;
};
export function Home({
  showReviewNotes
}: HomeProps) {
  return <div className="bold-home w-full bg-white text-ink" data-id="element-440" data-mp="29ek5l2bzdi1e">
    <a href="#main" className="sr-only left-4 top-4 z-50 bg-white px-5 py-3 font-bold text-ink focus:not-sr-only focus:absolute" data-id="element-441" data-mp="2di8d5l0m4dmn">Skip to main content</a>
    <SiteHeader data-id="element-442" data-mp="3kv0jusbstsmo" />
    <main id="main" data-id="element-443" data-mp="3kxmwv7hgl0ca"><Hero showReviewNotes={showReviewNotes} data-id="element-444" data-mp="3owlxifw5qaxx" /><TrustSection data-id="element-445" data-mp="3ovkhry47509v" /><CaseResult data-id="element-446" data-mp="3ov2fokuurru1" /><ResourceGallery data-id="element-447" data-mp="3oyym3bwf7jjy" /><MoreWins data-id="element-448" data-mp="30wrnkc0kxpdf" /><CaseReviewSection data-id="element-449" data-mp="30wjfcxfej88k" /></main>
    <SiteFooter data-id="element-450" data-mp="30vgnam6cezr2" />
  </div>;
}